/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileUploadResp } from '../../models/file-upload-resp';

export interface ApiFileGet$Params {
  fileId?: string;
}

export function apiFileGet(http: HttpClient, rootUrl: string, params?: ApiFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResp>> {
  const rb = new RequestBuilder(rootUrl, apiFileGet.PATH, 'get');
  if (params) {
    rb.query('fileId', params.fileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUploadResp>;
    })
  );
}

apiFileGet.PATH = '/api/File';
